import { isPlainObject, isString } from 'remeda'

// Public types ----------------------------------------------------------------

export type WebPushConfig = {
  readonly firebase: {
    readonly apiKey: string
    readonly appId: string
    readonly projectId: string
    readonly messagingSenderId: string
  }
  readonly vapidKey: string
}

// Private functions -----------------------------------------------------------

// Keeps only the Firebase fields required to register this browser for messaging.
const readConfig = (value: unknown, vapidKey: string): WebPushConfig | null =>
  isPlainObject(value) &&
  isString(value.apiKey) &&
  value.apiKey.length > 0 &&
  isString(value.appId) &&
  value.appId.length > 0 &&
  isString(value.projectId) &&
  value.projectId.length > 0 &&
  isString(value.messagingSenderId) &&
  value.messagingSenderId.length > 0
    ? {
        firebase: {
          apiKey: value.apiKey,
          appId: value.appId,
          projectId: value.projectId,
          messagingSenderId: value.messagingSenderId
        },
        vapidKey
      }
    : null

// Public functions ------------------------------------------------------------

// Missing or invalid build configuration disables optional browser push.
export const parseWebPushConfig = (
  raw: string | undefined,
  vapidKey: string | undefined
): WebPushConfig | null => {
  let config: WebPushConfig | null = null

  if (raw && vapidKey) {
    try {
      const parsed: unknown = JSON.parse(raw)
      config = readConfig(parsed, vapidKey)
    } catch {
      // An invalid deployment value must not prevent the application starting.
    }
  }

  return config
}
